import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CONSTANTS } from 'src/app/constants';
import { MissionsService } from './missions.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(
    private router: Router,
    private missionsService: MissionsService
  ) { }

  async navigateFromHome(route: string): Promise<void> {
    if (route === CONSTANTS.ROUTES.MISSION_CONFIG) {
      const missionId = this.missionsService.selectedMission$.getValue()?.missionId;
      if (missionId) { route = `${route}/${encodeURIComponent(missionId)}`; }
    }
    await this.router.navigateByUrl(`${CONSTANTS.ROUTES.HOME}/${route}`);
  }

  async navigateFromMissionConfig(route: string): Promise<void> {
    const missionId = this.missionsService.selectedMission$.getValue()?.missionId;
    const missionPath = missionId
      ? `${CONSTANTS.ROUTES.MISSION_CONFIG}/${encodeURIComponent(missionId)}`
      : CONSTANTS.ROUTES.MISSION_CONFIG;
    await this.navigateFromHome(`${missionPath}/${route}`);
  }

  isCurrentUrlFromHome(route: string): boolean {
    return this.router.url.includes(`${CONSTANTS.ROUTES.HOME}/${route}`);
  }
}
